function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { DESKTOP_NEXT_ELLIPSES as D_NEXT_ELL, DESKTOP_PREV_ELLIPSES as D_PREV_ELL, getActivePageKey, getTotalPageCountKey, MID, MOBILE_NEXT_ELLIPSES as M_NEXT_ELL, MOBILE_PREV_ELLIPSES as M_PREV_ELL, GREATER_THAN_8 } from "./index.js";
var generatePageLinkConfig = function generatePageLinkConfig(activePage, totalPageCount) {
  var _GREATER_THAN_;
  var totalPageCountKey = getTotalPageCountKey(totalPageCount);
  var activePageKey = getActivePageKey(activePage, totalPageCount);
  var pageLinkConfig = _defineProperty({
    1: {
      1: [] // render nothing
    },

    2: {
      1: [1, 2],
      2: [1, 2]
    },
    3: {
      1: [1, 2, 3],
      2: [1, 2, 3],
      3: [1, 2, 3]
    },
    4: {
      1: [1, 2, 3, 4],
      2: [1, 2, 3, 4],
      3: [1, 2, 3, 4],
      4: [1, 2, 3, 4]
    },
    5: {
      1: [1, 2, M_NEXT_ELL, 3, 4, 5],
      2: [1, 2, M_NEXT_ELL, 3, 4, 5],
      3: [1, 2, M_PREV_ELL, 3, M_NEXT_ELL, 4, 5],
      4: [1, 2, 3, M_PREV_ELL, 4, 5],
      5: [1, 2, 3, M_PREV_ELL, 4, 5]
    },
    6: {
      1: [1, 2, M_NEXT_ELL, 3, 4, 5, 6],
      2: [1, 2, M_NEXT_ELL, 3, 4, 5, 6],
      3: [1, 2, M_PREV_ELL, 3, M_NEXT_ELL, 4, 5, 6],
      4: [1, 2, 3, M_PREV_ELL, 4, M_NEXT_ELL, 5, 6],
      5: [1, 2, 3, 4, M_PREV_ELL, 5, 6],
      6: [1, 2, 3, 4, M_PREV_ELL, 5, 6]
    },
    7: {
      1: [1, 2, M_NEXT_ELL, 3, 4, 5, 6, 7],
      2: [1, 2, M_NEXT_ELL, 3, 4, 5, 6, 7],
      3: [1, 2, M_PREV_ELL, 3, M_NEXT_ELL, 4, 5, 6, 7],
      4: [1, 2, 3, M_PREV_ELL, 4, M_NEXT_ELL, 5, 6, 7],
      5: [1, 2, 3, 4, M_PREV_ELL, 5, M_NEXT_ELL, 6, 7],
      6: [1, 2, 3, 4, 5, M_PREV_ELL, 6, 7],
      7: [1, 2, 3, 4, 5, M_PREV_ELL, 6, 7]
    },
    8: {
      1: [1, 2, M_NEXT_ELL, 3, 4, 5, 6, 7, 8],
      2: [1, 2, M_NEXT_ELL, 3, 4, 5, 6, 7, 8],
      3: [1, 2, M_PREV_ELL, 3, M_NEXT_ELL, 4, 5, 6, 7, 8],
      4: [1, 2, 3, M_PREV_ELL, 4, M_NEXT_ELL, 5, 6, 7, 8],
      5: [1, 2, 3, 4, M_PREV_ELL, 5, M_NEXT_ELL, 6, 7, 8],
      6: [1, 2, 3, 4, 5, M_PREV_ELL, 6, M_NEXT_ELL, 7, 8],
      7: [1, 2, 3, 4, 5, 6, M_PREV_ELL, 7, 8],
      8: [1, 2, 3, 4, 5, 6, M_PREV_ELL, 7, 8]
    }
  }, GREATER_THAN_8, (_GREATER_THAN_ = {
    1: [1, 2, M_NEXT_ELL, 3, 4, 5, D_NEXT_ELL, totalPageCount],
    2: [1, 2, M_NEXT_ELL, 3, 4, 5, D_NEXT_ELL, totalPageCount],
    3: [1, 2, M_PREV_ELL, 3, M_NEXT_ELL, 4, 5, D_NEXT_ELL, totalPageCount],
    4: [1, 2, 3, M_PREV_ELL, 4, M_NEXT_ELL, 5, D_NEXT_ELL, totalPageCount]
  }, _defineProperty(_GREATER_THAN_, MID, [1, D_PREV_ELL, activePage - 1, M_PREV_ELL, activePage, M_NEXT_ELL, activePage + 1, D_NEXT_ELL, totalPageCount]), _defineProperty(_GREATER_THAN_, totalPageCount - 3, [1, D_PREV_ELL, activePage - 1, M_PREV_ELL, activePage, M_NEXT_ELL, totalPageCount - 2, totalPageCount - 1, totalPageCount]), _defineProperty(_GREATER_THAN_, totalPageCount - 2, [1, D_PREV_ELL, activePage - 2, activePage - 1, M_PREV_ELL, activePage, M_NEXT_ELL, totalPageCount - 1, totalPageCount]), _defineProperty(_GREATER_THAN_, totalPageCount - 1, [1, D_PREV_ELL, activePage - 3, activePage - 2, activePage - 1, M_PREV_ELL, activePage, totalPageCount]), _defineProperty(_GREATER_THAN_, totalPageCount, [1, D_PREV_ELL, activePage - 4, activePage - 3, activePage - 2, M_PREV_ELL, activePage - 1, activePage]), _GREATER_THAN_));
  return pageLinkConfig[totalPageCountKey][activePageKey];
};
export default generatePageLinkConfig;